import { useConsentReturn } from './useConsentReturn'

// Renders nothing; runs the consent-return side effect. Mounted inside the
// router + AuthProvider so the hook has both contexts.
export const ConsentReturnGate = () => {
  useConsentReturn()
  return null
}
